module.exports = __webpack_public_path__ + "static/media/google-play-w.07c3d120.png";